import type { AnyAction } from 'redux';

import {
  CHANGE_MESSAGES_WINDOW_STATE,
  SET_DELETED_CLIENT_MESSAGES,
  SET_DELETED_PRACTICE_MESSAGES,
  SET_NEW_CLIENT_MESSAGES,
  SET_NEW_PRACTICE_MESSAGES,
} from './actionTypes';
import { MessagesActionTypes, MessagesState, MessagesStates } from './types';

export const initialState: MessagesState = {
  messagesState: MessagesStates.MessagesClosed,
  newClientMessages: [],
  newPracticeMessages: [],
  deletedClientMessages: {},
  deletedPracticeMessages: {},
};

export default (state = initialState, incomingAction: AnyAction): MessagesState => {
  const action = incomingAction as MessagesActionTypes;

  switch (action.type) {
    case CHANGE_MESSAGES_WINDOW_STATE:
      return {
        ...state,
        messagesState: action.messagesState,
      };

    case SET_NEW_CLIENT_MESSAGES:
      return {
        ...state,
        newClientMessages: action.newClientMessages,
      };

    case SET_NEW_PRACTICE_MESSAGES:
      return {
        ...state,
        newPracticeMessages: action.newPracticeMessages,
      };

    case SET_DELETED_CLIENT_MESSAGES:
      return {
        ...state,
        deletedClientMessages: action.deletedClientMessages,
      };

    case SET_DELETED_PRACTICE_MESSAGES:
      return {
        ...state,
        deletedPracticeMessages: action.deletedPracticeMessages,
      };

    default:
      return state;
  }
};
